import styled from "styled-components"

export const TermsOfUse = () => {
    return (
        <StyledTermsOfUse>
            <h1>
                VILKÅR FOR BRUK AV PLATTFORMEN
            </h1>
            <h2>
                1. Beskrivelse av tjeneste
            </h2>
            <p>
                Plattformen er et nettbasert miljø som gir brukerne tilgang til et sett med verktøy som støtter utførelsen av tildelte oppgaver.
            </p>
            <p>
                Plattformen er ikke-kollaborativ av natur. Brukerens data, prosjekter, notater, beregningsresultater og øvrige ressurser deles ikke med andre brukere og er kun tilgjengelige innenfor vedkommendes individuelle arbeidsmiljø, med mindre annet uttrykkelig er angitt.
            </p>
            <p>
                Tjenesten omfatter blant annet:
            </p>
                <ul>
                    <li>
                        administrative og organisatoriske verktøy, som prosjektstyring, oppgavetavler (kanban), dashbord, dokumentarkiver og notatsystemer,
                    </li>
                    <li>
                        beregnings- og ingeniørverktøy, herunder beregningsmodeller, kalkulatorer, automatiseringer og systemer som støtter dataanalyse.
                    </li>
                </ul>
            <p>
                Brukeren får tilgang til de delene av Plattformen som er nødvendige for å utføre de oppgavene som er tildelt vedkommende.
            </p>
            <p>
                Enkelte modeller som er tilgjengelige gjennom Plattformen, er utviklet med utgangspunkt i metodikk, konsepter eller tidligere løsninger utviklet av Statens vegvesen. Med mindre annet uttrykkelig er angitt, er modellene som gjøres tilgjengelige på Plattformen ikke eid av Statens vegvesen, men forblir Plattformoperatørens eiendom.
            </p>
            <br/>
            <h1>
                DEL A — ADMINISTRATIVE VERKTØY
            </h1>
            <h2>
                2. Omfang av tilgang
            </h2>
            <p>
                Tilgang til administrative verktøy gis utelukkende med sikte på å utføre tildelte oppgaver eller samarbeid som gjennomføres via Plattformen.
            </p>
            <p>
                Omfanget av tilgjengelige funksjoner kan begrenses, utvides eller endres etter Plattformoperatørens skjønn.
            </p>
            <h2>
                3. Tilgangens varighet
            </h2>
            <p>
                Tilgang til administrative verktøy er ikke garantert på ubestemt tid.
            </p>
            <p>
                Plattformoperatøren kan når som helst suspendere, begrense eller avslutte tilgangen til hele eller deler av tjenestene.
            </p>
            <p>
                Tilgangen kan særlig avsluttes ved ferdigstillelse av en oppgave, et prosjekt eller et samarbeid, uten plikt til videre lagring av Brukerens data.
            </p>
            <h2>
                4. Brukerens data
            </h2>
            <p>
                Brukeren er selv ansvarlig for oppbevaring av egne data og for å ta sikkerhetskopier av informasjon som anses som viktig.
            </p>
            <p>
                Plattformoperatøren garanterer ikke permanent lagring av data etter at samarbeidet er avsluttet eller kontoen er slettet.
            </p>
            <h1>
                DEL B — BEREGNINGS- OG INGENIØRVERKTØY
            </h1>
            <h2>
                5. Modellenes karakter
            </h2>
            <p>
                Modeller, algoritmer, kalkulatorer, automatiseringer og øvrige beregningsverktøy stilles til rådighet for utførelse av bestemte arbeids-, test-, analyse- eller ingeniøroppgaver.
            </p>
            <p>
                Modellene kan fortløpende bli endret, oppdatert eller trukket tilbake uten forhåndsvarsel.
            </p>
            <h2>
                6. Begrensninger i bruk
            </h2>
            <p>
                Brukeren har ikke rett til å bruke Plattformen, dens modeller eller resultatene av disse til å skape, trene, gjenskape eller utvikle konkurrerende modeller, systemer eller tjenester.
            </p>
            <p>
                Det er særlig forbudt å:
            </p>
            <ul>
                <li>systematisk kopiere logikken bak modellenes virkemåte,</li>
                <li>hente ut regler, parametere eller metoder som ligger til grunn for modellenes funksjon,</li>
                <li>bygge datasett med sikte på å gjenskape modellenes virkemåte,</li>
                <li>bruke resultater fra Plattformen til å trene egne modeller eller kunstig intelligens-systemer uten forhåndsgodkjenning fra Plattformoperatøren.</li>
            </ul>
            <p>
                Ovennevnte begrensninger gjelder uavhengig av om modellene er beskyttet som forretningshemmeligheter eller av andre immaterielle rettigheter.
            </p>
            <h2>
                7. Resultatenes nøyaktighet
            </h2>
            <p>
                Til tross for rimelige anstrengelser kan Plattformen inneholde feil, unøyaktigheter eller utdatert informasjon.
            </p>
            <p>
                Resultater generert av modellene er kun ment som støtte og skal ikke anses som eneste informasjonsgrunnlag ved tekniske, prosjektmessige, regulatoriske, finansielle eller juridiske beslutninger.
            </p> 
            <p>
                Brukeren er forpliktet til selv å verifisere alle resultater, beregninger, analyser og anbefalinger som er innhentet gjennom Plattformen.
            </p>
            <p>
                Brukeren skal særlig alltid kontrollere at resultatene er i samsvar med gjeldende lovgivning, bransjestandarder, tekniske normer og oppdaterte krav fra relevante tilsyns- og reguleringsmyndigheter.
            </p>
            <h2>
                8. Ingen garantier
            </h2>
            <p>
                Beregningsverktøyene leveres «som de er» («as is»).
            </p>
            <p>
                Plattformoperatøren gir ingen garantier for riktighet, fullstendighet, salgbarhet eller egnethet for et bestemt formål når det gjelder modeller eller resultater generert av Plattformen.
            </p>
            <h2>
                9. Ansvar
            </h2>
            <p>
                Det endelige ansvaret for bruk av resultater generert av Plattformen ligger hos Brukeren.
            </p>
            <p>
                Plattformoperatøren er ikke ansvarlig for konsekvenser av beslutninger som tas på grunnlag av resultater oppnådd ved bruk av Plattformen.
            </p>
        </StyledTermsOfUse>
    )
}

const StyledTermsOfUse = styled.div`

    font-size: ${({theme}) => theme.fontSize.sm};

    h1
    {
        font-size: ${({theme}) => theme.fontSize.lg};
        line-height: 1.5em;
        display: block;
        margin: ${({theme}) => theme.spacing.sm} 0;
    }

    h2
    {
        font-size: ${({theme}) => theme.fontSize.md};
        line-height: 1.5em;
        margin: ${({theme}) => theme.spacing.sm} 0;
        display: block;
    }

    p
    {
        line-height: 1.5em;
        margin: ${({theme}) => theme.spacing.sm} 0;
    }

    ul
    {
        padding-left: ${({theme}) => theme.spacing.lg};
        padding-top: ${({theme}) => theme.spacing.sm};
        padding-bottom: ${({theme}) => theme.spacing.sm};

        li
        {
            margin-bottom: ${({theme}) => theme.spacing.sm};
        }
    }
`